export default {
  locale: "es",
  name: "Partners",
  translation: { displayName: "Traducciones" },
  fields: {
    list: [],
    form: [],
  },
};
